import { render, staticRenderFns } from "./PeopleShow.vue?vue&type=template&id=3cd7693b&lang=pug&"
import script from "./PeopleShow.vue?vue&type=script&lang=js&"
export * from "./PeopleShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports